export default __webpack_public_path__ + "static/media/Way.a8fa4b71.svg";